import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'checkboxAll',
    'loadingOverlay',
    'loadingPlaceholder',
    'selectAllTrigger',
    'selectNoneTrigger',
  ]

  connect() {
    setTimeout(() => {
      this.#checkForAllFoldersLoaded()
    }, 1000)
  }

  selectAllTriggerTargetConnected(trigger) {
    const folderType = trigger.dataset.folderType
    trigger.addEventListener('click', () => {
      this.#handleSelection(folderType, true)
    })
  }

  selectNoneTriggerTargetConnected(trigger) {
    const folderType = trigger.dataset.folderType
    trigger.addEventListener('click', () => {
      this.#handleSelection(folderType, false)
    })
  }

  #checkForAllFoldersLoaded() {
    if(this.loadingPlaceholderTargets.length == 0) {
      this.loadingOverlayTargets.forEach((overlay) => {
        overlay.remove()
      })
    } else {
      setTimeout(() => {
        this.#checkForAllFoldersLoaded()
      }, 1000)
    }
  }

  #handleSelection(folderType, checked) {
    this.checkboxAllTargets.forEach((checkboxAll) => {
      if (checkboxAll.dataset.folderType === folderType) {
        checkboxAll.checked = checked
        checkboxAll.dispatchEvent(new Event('change', { bubbles: true }))
      }
    })
  }
}
